import React, { useState, useEffect } from 'react';
import { HiOutlineArrowLeft, HiOutlineUserCircle } from 'react-icons/hi';
import { getAdminSessionInfo, returnToAdminAccount } from '../../services/authService';

const AdminSessionIndicator = () => {
  const [adminSessionInfo, setAdminSessionInfo] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    // Check if we're in an admin session
    const sessionInfo = getAdminSessionInfo();

    // Validate admin session info has required fields
    if (sessionInfo?.isAdminSession && sessionInfo?.adminUser && sessionInfo?.targetUser) {
      setAdminSessionInfo(sessionInfo);
    } else {
      // Invalid or missing admin session - clear it
      if (sessionInfo) {
        console.warn('AdminSessionIndicator: Invalid admin session info, clearing');
        localStorage.removeItem('admin_session_info');
      }
      setAdminSessionInfo(null);
    }
  }, []);

  const handleReturnToAdmin = async () => {
    setIsLoading(true);
    try {
      await returnToAdminAccount();
      // Use window.location.href for a full page reload to ensure clean state
      // This prevents any React state issues from interfering with navigation
      window.location.href = '/admin/users';
    } catch (error) {
      console.error('Failed to return to admin account:', error);
      // Fallback: clear session info and redirect to admin login
      localStorage.removeItem('admin_session_info');
      window.location.href = '/admin';
    } finally {
      setIsLoading(false);
    }
  };

  // Don't render if not in admin session
  if (!adminSessionInfo?.isAdminSession) {
    return null;
  }

  return (
    <div className="bg-yellow-50 border-b border-yellow-200 shadow-sm">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-12">
          <div className="flex items-center space-x-3">
            <HiOutlineUserCircle className="h-5 w-5 text-yellow-600" />
            <div className="text-sm">
              <span className="text-yellow-800 font-medium">Admin View:</span>
              <span className="text-yellow-700 ml-1">
                Viewing as {adminSessionInfo.targetUser?.name || 'user'}
              </span>
            </div>
          </div>

          {/* Return to Admin Button */}
          <button
            onClick={handleReturnToAdmin}
            disabled={isLoading}
            className="inline-flex items-center px-3 py-1 border border-yellow-300 rounded-md text-sm font-medium text-yellow-700 bg-yellow-100 hover:bg-yellow-200 hover:border-yellow-400 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-yellow-500 disabled:opacity-50 disabled:cursor-not-allowed transition-colors"
          >
            <HiOutlineArrowLeft className="h-4 w-4 mr-1" />
            {isLoading ? 'Returning...' : 'Return to Admin'}
          </button>
        </div>
      </div>
    </div>
  );
};

export default AdminSessionIndicator;
